import { Button } from '@consta/uikit/Button'
import { User } from '@consta/uikit/User'
import { withTooltip } from '@consta/uikit/withTooltip'
import { selectDisplayName, selectUserName, useAppSelector } from '@core/core/store'
import { IconConsole, ThemeSwitch } from '@library/components'
import type { FC } from 'react'
import { lazy, useCallback, useState } from 'react'
import { useParams } from 'react-router-dom'

const TaskDispatcher = lazy(() => import('@utils/TaskDispatcher'))

const UserWithTooltip = withTooltip({
  mode: 'mouseover',
  appearTimeout: 200,
  direction: 'downCenter',
})(User)

export const ProjectRightSideHeader: FC = () => {
  const [isDispatcherOpened, setIsDispatcherOpened] = useState(false)
  const { projectId = '' } = useParams()

  const onToggleDispatcherOpen = useCallback((isOpen?: boolean) => {
    setIsDispatcherOpened(prev => (isOpen !== undefined ? isOpen : !prev))
  }, [])

  const displayName = useAppSelector(selectDisplayName)
  const userName = useAppSelector(selectUserName)

  return (
    <>
      <Button
        view="ghost"
        size="xs"
        label="Диспетчер задач"
        iconLeft={IconConsole}
        onClick={() => {
          onToggleDispatcherOpen()
        }}
      />
      <ThemeSwitch />
      <UserWithTooltip
        status="available"
        name={userName}
        onlyAvatar={true}
        tooltipProps={{ tooltipContent: displayName }}
      />
      <TaskDispatcher
        projectId={projectId}
        isModalOpen={isDispatcherOpened}
        onToggleDispatcherOpen={onToggleDispatcherOpen}
      />
    </>
  )
}
